import initialOf from './initialOf'

// A–Z-Register wie in der alten Aussteller-Maske (Spec Abschnitt 8). Sortiert
// selbst; fuer eine bereits sortierte Liste gibt es groupConsecutiveByInitial.
const groupByInitial = (items, labelKey = 'name') => {
    const groups = new Map()

    for (const item of items) {
        const letter = initialOf(item[labelKey])
        groups.set(letter, [...(groups.get(letter) || []), item])
    }

    return [...groups.entries()]
        .sort(([a], [b]) => a.localeCompare(b, 'de'))
        .map(([letter, entries]) => ({
            letter,
            items: entries.sort((a, b) => String(a[labelKey] || '').localeCompare(String(b[labelKey] || ''), 'de'))
        }))
}

export default groupByInitial
